import { PoinzApiClient } from '../../api';
import { ReferralCampaign } from './types';
import { ROOT } from './config';
import { IEntityTypes } from 'partnerClient/search/types';

const CAMPAIGNS = 'campaigns';
const PUBLIC = 'public';
const PROMOTED = 'promoted';
const apiRoot = `/${ROOT}/${CAMPAIGNS}`;

export interface GetPublicCampaignArgs {
  code?: string;
  entityType?: IEntityTypes;
  entityId?: number;
}

const getPublicCampaign =
  (apiClient: PoinzApiClient) =>
  async (queryParams: GetPublicCampaignArgs): Promise<ReferralCampaign> => {
    const result = await apiClient.get(`${apiRoot}/${PUBLIC}`, {
      queryParams
    });

    return result.body;
  };

const getPromotedCampaignCode =
  (apiClient: PoinzApiClient) => async (): Promise<{ code: string }> => {
    const result = await apiClient.get(`${apiRoot}/${PROMOTED}`, {});
    return result.body;
  };

export default (apiClient: PoinzApiClient) => ({
  getPublicCampaign: getPublicCampaign(apiClient),
  getPromotedCampaignCode: getPromotedCampaignCode(apiClient)
});
